import React from "react";

const Recipe = ({title, calories, image, ingredients}) => {
    return(
        <div className="recipe">
            <h1 className="recipe-title">{title}</h1>
            <ol className="recipe-list">
                {
                    ingredients.map((ingredient, i) => (
                        <li key={i}>{ingredient.text}</li>
                    ))
                }
            </ol>
            <p className="recipe-calories">{Math.floor(calories)} calories</p>
            <img src={image} alt=""/>
        </div>
    );
};

export default Recipe;